export default __webpack_public_path__ + "img/ftflfzkr.87f3dc7a.svg";